import {
    openTheCurtain,
    closingTheCurtain,
    closeTheCurtain,
    getCurtainValue,
    setCurtainEndedState,
    setCurtainArmageddonState,
    isCurtainLocked,
    lockCurtain,
} from '.'
import { AppThunk } from 'redux/store'
import { Timer, resetTimer } from 'redux/slices/timers'
import { CURTAIN_ANIMATION_IN_SECONDS } from 'constants.js'
import { createTimer } from 'redux/slices/timers/thunks'
import { isCurtainClosing } from 'utils/curtain'

export const openCurtain = (resetTimers: Timer[] = []): AppThunk => async (dispatch, getState) => {
    if (isCurtainLocked(getState())) return

    if (resetTimers.length) {
        resetTimers.forEach(timer => {
            dispatch(resetTimer(timer))
        })
    }
    dispatch(openTheCurtain())
}

export const closeCurtain = (lockOnFinish: boolean = false): AppThunk => async (dispatch, getState) => {
    if (isCurtainLocked(getState())) return

    dispatch(closingTheCurtain())
    //We want to make sure that this is the only alive timer to start closing the curtain
    dispatch(resetTimer(Timer.SET_PAGE_CLOSING_CURTAIN))
    dispatch(
        createTimer(Timer.SET_PAGE_CLOSING_CURTAIN, CURTAIN_ANIMATION_IN_SECONDS * 1000, () => {
            const curtainValue = getCurtainValue(getState())
            if (isCurtainClosing(curtainValue)) {
                dispatch(closeTheCurtain())

                if (lockOnFinish) {
                    dispatch(lockCurtain())
                }
            }
        }),
    )
}

export const closeCurtainWithEndedState = (): AppThunk => async (dispatch, getState) => {
    if (isCurtainLocked(getState())) return

    dispatch(setCurtainEndedState())
    dispatch(closeCurtain())
}

export const closeCurtainWithArmageddonState = (message?: string): AppThunk => async dispatch => {
    dispatch(setCurtainArmageddonState(message))
    dispatch(closeCurtain(true))
}
